export const LIMIT_PER_TRANSACTION = 30_000;
